'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { AuthProvider } from '@/features/auth/contexts/AuthContext';
import { WorkspaceProvider } from '@/features/escritorio/components/providers/WorkspaceProvider';
import { AuthRefreshProvider } from '@/shared/components/auth/AuthRefreshProvider';
import { DatadogRum } from '@/shared/components/features/DatadogRum';
import { PostHog } from '@/shared/components/features/PostHog';
import { ToastProvider } from '@/shared/providers';
import { store } from '@/store';
interface ProvidersProps {
  children: ReactNode;
}
export function Providers(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DatadogRum />;
    t2 = <PostHog />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <Provider store={store}>{t1}{t2}<AuthProvider><AuthRefreshProvider><WorkspaceProvider><ToastProvider>{children}</ToastProvider></WorkspaceProvider></AuthRefreshProvider></AuthProvider></Provider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}